export default __webpack_public_path__ + "static/media/ceramx-okkusaler-laesion.3884c2c3.png";